import React from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { Icon } from './styles'

export function VatHint(): JSX.Element {
  const { t } = useTranslation()
  const title = t('web.anti-fraud.vat-drawer-hint')
  return (
    <Tooltip title={title}>
      <Icon theme="twoTone" twoToneColor="#1890ff" type="info-circle" />
    </Tooltip>
  )
}
